// extracted by mini-css-extract-plugin
module.exports = {"PopUp":"PopUp_PopUp__1SDQR","PopUpBackground":"PopUp_PopUpBackground__2nHPS","PopUpContent":"PopUp_PopUpContent__2QshX"};